<template>
  <div class="sign-up">
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <div class="box">
              <p class="title is-5">{{ $t('signup-view.title') }}</p>
              <b-field :label="$t('signup-view.firstname-field')">
                <b-input required @keydown.native.enter="signUp" v-model="name.first"
                         :placeholder="$t('signup-view.firstname-placeholder')" tabindex="1"></b-input>
              </b-field>
              <b-field :label="$t('signup-view.lastname-field')">
                <b-input required @keydown.native.enter="signUp" v-model="name.last"
                         :placeholder="$t('signup-view.lastname-placeholder')" tabindex="2"></b-input>
              </b-field>
              <b-field :label="$t('signup-view.email-field')">
                <b-input required @keydown.native.enter="signUp" v-model="email" type="text"
                         :placeholder="$t('signup-view.email-placeholder')" tabindex="3"></b-input>
              </b-field>
              <b-field :label="$t('signup-view.password-field')">
                <b-input required @keydown.native.enter="signUp" v-model="password" type="password"
                         :placeholder="$t('signup-view.password-placeholder')" tabindex="4"/>
              </b-field>
              <b-button @keydown.native.enter="signUp" @click="signUp" type="is-primary" tabindex="5" expanded
                        style="margin-top: 32px">
                {{ $t('signup-view.signup-button') }}
              </b-button>
              <p class="subtitle">
                {{ $t('signup-view.back-to-login-text-part1') }}
                <router-link to="/login">{{ $t('signup-view.back-to-login-text-part2') }}</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  name: "signup",
  data() {
    return {
      name: {
        first: "",
        last: ""
      },
      email: "",
      password: ""
    };
  },
  methods: {
    signUp: function () {
      if (!this.formIsValid) {
        this.showError(this.$t("signup-view.form-validation_error"))
        return
      }
      this.$parent.isLoading = true
      firebase
          .auth()
          .createUserWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.createUser()
            this.sendVerificationEmail()
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError("Oops. " + error.message);
          });
    },
    sendVerificationEmail: function () {
      firebase.auth().currentUser.sendEmailVerification()
          .then(() => {
            this.showSuccess(this.$t("user-verification.verification-email-sent"));
            this.$parent.isLoading = false
            this.$buefy.dialog.confirm({
              title: this.$t('user-verification.title').toString(),
              message: this.$t('user-verification.description').toString() + " " + this.email,
              confirmText: this.$t('common.ok').toString(),
              cancelText: this.$t('common.close').toString(),
            })
            firebase.auth().signOut()
          })
          .catch((error) => {
            this.$parent.isLoading = false
            this.showError(error.message);
          });
    },
    createUser: function () {
      const functions = firebase.app().functions("europe-west3");
      const insertUserFunction = functions.httpsCallable(this.getSubmitEndpoint());
      insertUserFunction({
        action: "insert_user",
        name: this.name,
        email: this.email,
        roles: ["inactive"]
      }).then((result) => {
        console.log("create user result: ", result.data);
      }).catch((error) => {
        this.showError(error.message)
      });
    }
  },
  computed: {
    formIsValid() {
      return this.name.first !== "" && this.name.last.empty !== "" && this.email !== "" && this.password !== "";
    }
  }
};
</script>

<style scoped>
.sign-up {
  margin-top: 40px;
}

input {
  margin: 10px 0;
  padding: 15px;
}

button {
  margin-top: 10px;
  padding: 15px;
  cursor: pointer;
}

.subtitle {
  margin-top: 40px;
  font-size: 13px;
}

.subtitle a {
  text-decoration: underline;
  cursor: pointer;
}
</style>